<template>
  <div class="w-100 h-100 d-flex justify-content-center">
    <SConfirmation
      :appConfig="getAppConfig"
      :orderId="getOrderId"
      :firstName="getFirstName"
      :departurePlace="getDeparturePlace"
      :arrivalPlace="getArrivalPlace"
      @toMainPage="toMainPage"
      @handleServerError="handleServerError"
    />
  </div>
</template>

<script lang="ts">
import type { NavigationGuardNext, Route } from 'vue-router';

export default {
  name: 'ConfirmationPage',
  beforeRouteEnter(to: Route, _from: Route, next: NavigationGuardNext) {
    const hasOrderIdProperty = Object.prototype.hasOwnProperty.call(to.params, 'orderId');
    if (hasOrderIdProperty) {
      next();
    } else {
      // redirect to home page
      next('');
    }
  },
};
</script>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { SConfirmation } from '@slg/web-customer-shared';
import appConfig from '@/appConfig';
import {
  useStore, useRouter, useRouteRef, useGlobalErrorDialog, useGtm,
} from '@/composables';

const store = useStore();
const router = useRouter();
const route = useRouteRef();
const { setGlobalError } = useGlobalErrorDialog();
const { trackGtmEvent } = useGtm();

const getFirstName = computed(() => store.getters['auth/getFirstName']);
const getDeparturePlace = computed(() => store.getters['booking/getDeparturePlace']);
const getArrivalPlace = computed(() => store.getters['booking/getArrivalPlace']);
const getOrderId = computed(() => route.value.params.orderId);
const getAppConfig = computed(() => appConfig);

function toMainPage() {
  router.push({ name: 'Booking' });
}

async function handleServerError(e: unknown) {
  await setGlobalError(e as any);
}

onMounted(() => {
  trackGtmEvent(
    'Confirmation page',
    'Page',
    'Loaded',
    'Confirmation page is loaded',
  );
});

onBeforeUnmount(() => {
  store.commit('booking/clearBookingState');
  store.commit('opsZone/clearOpsZone');
});
</script>

<style scoped>

</style>
